export enum TipoFormatoAssinaturaEnum
{
    "Assinatura Qualificada - ICP-Brasil" = 1,//"Assinatura Digital - Online" = 1,
    //"Assinatura Digital - Offline" = 2,
    "Assinatura Simples - Com senha" = 3,//"Assinatura Eletrônica - com senha" = 3,
    //"Assinatura Eletrônica - com e-CPF" = 4
    "Assinatura Avançada - GOV.BR" = 5//"Assinatura Eletrônica Avançada - Gov.br" = 5
}